// import React from 'react';
// import { 
//   ShieldCheck, ShieldAlert, Laptop, Lock, 
//   ChevronLeft, CheckCircle2, FileText, Fingerprint, 
//   HelpCircle, ShoppingCart 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function CyberAndECommerceServices() {
  
//   // Core e-commerce and cyber law offerings
//   const techServices = [
//     {
//       title: "امتثال منصات التجارة الإلكترونية",
//       desc: "صياغة الشروط والأحكام (Terms of Service)، سياسات الاسترجاع والاستبدال، وضمان مطابقة المتاجر والتطبيقات الإلكترونية لمتطلبات نظام التجارة الإلكترونية السعودي ولائحته التنفيذية.",
//       icon: <ShoppingCart className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حوكمة حماية البيانات الشخصية (PDPL)",
//       desc: "بناء سياسات الخصوصية، ومراجعة وتدقيق آليات جمع ومعالجة بيانات المستخدمين وتأمينها وفقاً لنظام حماية البيانات الشخصية السعودي لتفادي المخالفات الجسيمة.",
//       icon: <Fingerprint className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حقوق الملكية الفكرية الرقمية",
//       desc: "تسجيل وحماية حقوق الملكية الفكرية لشيفرات البرمجة (Source Codes)، براءات اختراع الخوارزميات، واجهات المستخدم، وعقود تطوير البرمجيات وحقوق النشر الرقمية.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "دعاوى الجرائم المعلوماتية",
//       desc: "التمثيل القانوني والتقاضي في قضايا اختراق الأنظمة والشبكات، تسريب البيانات الحساسة، الاحتيال المالي الإلكتروني، التشهير الرقمي، والاعتداء على العلامات التجارية عبر الإنترنت.",
//       icon: <ShieldAlert className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات التجارة الإلكترونية وقانون الفضاء السيبراني"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حوكمة الأنظمة الرقمية وتأمين الامتثال السيبراني</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات التجارة الإلكترونية وقانون الفضاء السيبراني</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نهيئ لشركتك الناشئة أو منصتك الرقمية الحماية التشريعية المتكاملة، ونضمن توافق عملياتك التقنية مع أنظمة الأمن السيبراني وحماية البيانات، مع تقديم دفاع جنائي وفني صارم في مواجهة الجرائم المعلوماتية.
//           </p>
//         </div>
//       </section>

//       {/* Analytical & Tech Growth Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               تأمين الأصول الرقمية والامتثال للمنظومة التشريعية الحديثة
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               العمل في الفضاء الرقمي يفرض على المنشآت مسؤوليات قانونية تفوق التجارة التقليدية؛ حيث إن أي ثغرة في شروط استخدام التطبيق، أو سوء إدارة لبيانات العملاء، قد يضع منشأتك تحت طائلة المساءلة والغرامات من قبل الجهات التنظيمية.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               يقدم مستشارونا التقنيون والقانونيون صياغة محكمة تحمي أصحاب العمل من المسؤولية عن إساءة استخدام المنصات من قبل الأطراف الثالثة، ونساعدك في بناء خطط استجابة قانونية فورية لحالات اختراق البيانات أو الابتزاز السيبراني، بما يحفظ سمعة علامتك واستمرارية نموها في السوق الرقمي.
//             </p>
//           </div>
          
//           {/* Key Cyber Pillars Checklist Box */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <Lock className="w-5 h-5 text-amber-600" /> مرتكزات الحماية الرقمية والامتثال:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**شرعية معالجة البيانات:** التأكد من الحصول على موافقات المستخدمين الصريحة لجمع البيانات وفق شروط الـ (PDPL).</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**موثوقية التعاملات المالية:** حوكمة بوابات الدفع الإلكتروني والتعاقد الآمن مع شركات الشحن والخدمات اللوجستية.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**الحصانة ضد الثغرات العقدية:** صياغة بنود إخلاء المسؤولية (Disclaimers) وحدود التعويض لحماية مشغلي المنصات.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Capability Block */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">خدماتنا في القانون الرقمي والسيبراني</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">صياغة وحوكمة وتمثيل قضائي متكامل لحماية استثماراتك في الاقتصاد الرقمي</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {techServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Strict Legal Consequence Disclaimer */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <HelpCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">مخاطر عدم الامتثال لنظام حماية البيانات الشخصية:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               تفرض التشريعات السعودية عقوبات صارمة على المنصات والشركات التي تقوم بجمع أو تسريب أو معالجة البيانات الشخصية للمستخدمين دون أساس نظامي أو دون اتخاذ التدابير السيبرانية الكافية لحمايتها. تصل الغرامات النظامية إلى **5 ملايين ريال سعودي** مع إمكانية مضاعفتها في حال التكرار، بالإضافة إلى عقوبات جنائية تشمل السجن عند تسريب البيانات الحساسة بنية الإضرار. مواءمة منشأتك رقمياً هي وقاية استباقية أساسية لاستمرار أعمالك.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Conversion Optimization */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Laptop className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تمتلك منصة رقمية أو تواجه نزاعاً سيبرانياً؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل مع فريقنا القانوني والتقني المتخصص اليوم لمراجعة وثائق منصتك، وضمان امتثالها الكامل للأنظمة السيبرانية، أو لتمثيلك في قضايا الجرائم المعلوماتية بحصافة وكفاءة.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب باقة الامتثال الرقمي وحوكمة البيانات
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  ShieldCheck, ShieldAlert, Laptop, Lock, 
  ChevronLeft, CheckCircle2, FileText, Fingerprint, 
  HelpCircle, ShoppingCart 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function CyberAndECommerceServices() {
  
  // Core e-commerce and cyber law offerings - Refactored to Navy Light
  const techServices = [
    {
      title: "امتثال منصات التجارة الإلكترونية",
      desc: "صياغة الشروط والأحكام (Terms of Service)، سياسات الاسترجاع والاستبدال، وضمان مطابقة المتاجر والتطبيقات الإلكترونية لمتطلبات نظام التجارة الإلكترونية السعودي ولائحته التنفيذية.",
      icon: <ShoppingCart className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حوكمة حماية البيانات الشخصية (PDPL)",
      desc: "بناء سياسات الخصوصية، ومراجعة وتدقيق آليات جمع ومعالجة بيانات المستخدمين وتأمينها وفقاً لنظام حماية البيانات الشخصية السعودي لتفادي المخالفات الجسيمة.",
      icon: <Fingerprint className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حقوق الملكية الفكرية الرقمية",
      desc: "تسجيل وحماية حقوق الملكية الفكرية لشيفرات البرمجة (Source Codes)، براءات اختراع الخوارزميات، واجهات المستخدم، وعقود تطوير البرمجيات وحقوق النشر الرقمية.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "دعاوى الجرائم المعلوماتية",
      desc: "التمثيل القانوني والتقاضي في قضايا اختراق الأنظمة والشبكات، تسريب البيانات الحساسة، الاحتيال المالي الإلكتروني، التشهير الرقمي، والاعتداء على العلامات التجارية عبر الإنترنت.",
      icon: <ShieldAlert className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات التجارة الإلكترونية وقانون الفضاء السيبراني"
        description="نهيئ لمنصتكم الرقمية الامتثال التشريعي الكامل والحماية السيبرانية والقانونية المتكاملة"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حوكمة الأنظمة الرقمية وتأمين الامتثال السيبراني</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات التجارة الإلكترونية وقانون الفضاء السيبراني</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نهيئ لشركتك الناشئة أو منصتك الرقمية الحماية التشريعية المتكاملة، ونضمن توافق عملياتك التقنية مع أنظمة الأمن السيبراني وحماية البيانات، مع تقديم دفاع جنائي وفني صارم في مواجهة الجرائم المعلوماتية.
          </p>
        </div>
      </section>

      {/* Analytical & Tech Growth Framework */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              تأمين الأصول الرقمية والامتثال للمنظومة التشريعية الحديثة
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              العمل في الفضاء الرقمي يفرض على المنشآت مسؤوليات قانونية تفوق التجارة التقليدية؛ حيث إن أي ثغرة في شروط استخدام التطبيق، أو سوء إدارة لبيانات العملاء، قد يضع منشأتك تحت طائلة المساءلة والغرامات من قبل الجهات التنظيمية.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يقدم مستشارونا التقنيون والقانونيون صياغة محكمة تحمي أصحاب العمل من المسؤولية عن إساءة استخدام المنصات من قبل الأطراف الثالثة، ونساعدك في بناء خطط استجابة قانونية فورية لحالات اختراق البيانات أو الابتزاز السيبراني، بما يحفظ سمعة علامتك واستمرارية نموها في السوق الرقمي.
            </p>
          </div>
          
          {/* Key Cyber Pillars Checklist Box - Refactored to Executive Light Mode */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <Lock className="w-5 h-5 text-blue-700" /> مرتكزات الحماية الرقمية والامتثال:
            </h3>
            
            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">شرعية معالجة البيانات:</strong> التأكد من الحصول على موافقات المستخدمين الصريحة لجمع البيانات وفق شروط الـ (PDPL).</p>
            </div>

            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">موثوقية التعاملات المالية:</strong> حوكمة بوابات الدفع الإلكتروني والتعاقد الآمن مع شركات الشحن والخدمات اللوجستية.</p>
            </div>

            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">الحصانة ضد الثغرات العقدية:</strong> صياغة بنود إخلاء المسؤولية (Disclaimers) وحدود التعويض لحماية مشغلي المنصات.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Capability Block - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">خدماتنا في القانون الرقمي والسيبراني</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">صياغة وحوكمة وتمثيل قضائي متكامل لحماية استثماراتك في الاقتصاد الرقمي</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {techServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strict Legal Consequence Disclaimer - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <HelpCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">مخاطر عدم الامتثال لنظام حماية البيانات الشخصية:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              تفرض التشريعات السعودية عقوبات صارمة على المنصات والشركات التي تقوم بجمع أو تسريب أو معالجة البيانات الشخصية للمستخدمين دون أساس نظامي أو دون اتخاذ التدائير السيبرانية الكافية لحمايتها. تصل الغرامات النظامية إلى <strong className="text-indigo-950">5 ملايين ريال سعودي</strong> مع إمكانية مضاعفتها في حال التكرار، بالإضافة إلى عقوبات جنائية تشمل السجن عند تسريب البيانات الحساسة بنية الإضرار. مواءمة منشأتك رقمياً هي وقاية استباقية أساسية لاستمرار أعمالك.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Conversion Optimization - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Laptop className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تمتلك منصة رقمية أو تواجه نزاعاً سيبرانياً؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل مع فريقنا القانوني والتقني المتخصص اليوم لمراجعة وثائق منصتك، وضمان امتثالها الكامل للأنظمة السيبرانية، أو لتمثيلك في قضايا الجرائم المعلوماتية بحصافة وكفاءة.
        </p>
        <button className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب باقة الامتثال الرقمي وحوكمة البيانات
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}

